import { render, staticRenderFns } from "./TaskReview.vue?vue&type=template&id=3a778544"
import script from "./TaskReview.vue?vue&type=script&lang=js"
export * from "./TaskReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports